<template>
  <TableGradient
      icon-name="folder"
      :title="$t('integrationHelper.listagem.titulo_pagina')"
      :text-empty="$t('integrationHelper.listagem.table.empty')"
      route-new="vns.integration_helper.create"
      :text-new="$t('integrationHelper.listagem.novo')"
      :fields="fields"
      :fields-filter="filter"
      :items="integrationHelpers"
      :paginator="pagination"
      :loading="isLoading"
      @list="evt => $store.dispatch('integrationHelper/listAll', evt)"
      table-data>
    <template v-slot:cell(id)="linha">
      <router-link :id="'link-edit-' + linha.index"
                   :to="{ name: 'vns.integration_helper.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('integrationHelper.listagem.table.editar') }}
      </router-link>
    </template>
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.status, 'badge badge-danger': !linha.item.status}">
          <i :class="linha.item.status ? 'fas fa-check' : 'fas fa-ban'"/>
      </span>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import TableData from "@/components/TableData";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableData, TableGradient},
  computed: {
    ...mapGetters({
      store_isLoading: 'integrationHelper/isLoading',
      integrationHelpers: 'integrationHelper/all',
      pagination: 'integrationHelper/pagination'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('integrationHelper.listagem.table.nome'), sortable: true},
        {key: 'class', label: this.$t('integrationHelper.listagem.table.classe'), sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'created_at', thClass: 'd-none', tdClass: 'd-none'},
        {key: 'updated_at', thClass: 'd-none', tdClass: 'd-none'},
        {key: 'id', label: this.$t('integrationHelper.listagem.table.editar')}
      ],
      filter: [
        {key: 'name', label: this.$t('integrationHelper.listagem.table.nome')},
        {key: 'class', label: this.$t('integrationHelper.listagem.table.classe')},
      ],
    }
  },
  methods: {
    ...mapActions([
      'integrationHelper/listAll'
    ])
  },
  mounted() {
    this['integrationHelper/listAll']()
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
